@if (translate.get('primeng') | async; as config) {
  <router-outlet />
} @else {
  <ng-template #loadingTemplate> ... </ng-template>
}

<p-confirmDialog [closable]="false"></p-confirmDialog>
<p-toast></p-toast>
<app-root-menu></app-root-menu>
